<div class="container">
  <ng-container *ngIf="value > 0">
    <ng-container *ngTemplateOutlet="positiveDelta; context: { value: value }"></ng-container>
  </ng-container>
  <ng-container *ngIf="value === 0 && showNeutral">
    <ng-container *ngTemplateOutlet="neutralDelta"></ng-container>
  </ng-container>
  <ng-container *ngIf="value < 0">
    <ng-container *ngTemplateOutlet="negativeDelta; context: { value: value }"></ng-container>
  </ng-container>
</div>

<ng-template #negativeDelta let-value="value">
  <div class="delta-negative">
    <mat-icon class="delta-triangle">arrow_drop_down</mat-icon>
    {{ absVal(value) | number : '1.0-2' }}
  </div>
</ng-template>

<ng-template #positiveDelta let-value="value">
  <div class="delta-positive">
    <mat-icon class="delta-triangle">arrow_drop_up</mat-icon>
    {{ value | number : '1.0-2' }}
  </div>
</ng-template>

<ng-template #neutralDelta>
  <div class="delta-neutral">no change</div>
</ng-template>
